import React from 'react';
import PropTypes from 'prop-types';
import { toInteger } from 'lodash';
import { connect } from 'react-redux';

class CategorySelectComponent extends React.Component {
    onChange = e => this.props.onChangeCategory(toInteger(e.target.value));

    render() {
        const { i18n, categories, categoryId } = this.props;
        return (
            <div id="annuaire-rubriques-container" className="flex-container-h flex-center-alt">
                <label htmlFor="filtre" className="selection-filtre hidden-mobonly">
                    {`${i18n.CATEGORIE}: `}
                </label>
                <div id="annuaire-rubriques" className="select bt-fourth">
                    <select
                        id="annuaire-rubriques-select"
                        value={categoryId}
                        onChange={this.onChange}>
                        <option value={-1}>{i18n.ALL_CATEGORIES}</option>
                        {categories.map((category, i) => {
                            return (
                                <option value={category.id} key={i}>
                                    {category.label}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        );
    }
}

CategorySelectComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY
    };
};

export default connect(mapStateToProps)(CategorySelectComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/CategorySelectComponent.js